import {
  Box,
  Center,
  Container,
  Divider,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import FooterTagsCompiled from "./FooterTagsCompiled";
import NewsLetterSection from './NewsLetterSection'
import {  useSelector } from "react-redux";
const Footer = () => {
  const mobileView = useSelector((state) => state.mobileView);

  if(mobileView) {
    return(
      <></>
    )
  }

  return (
    <Box width={"80%"} margin={"auto"} paddingBlock="34px">
      <Flex>
        <Box>
          <Image
            src="https://i.ibb.co/1959HjW/udyog-logo-home.png"
            alt="Udyog Logo"
            w={"40px"}
            minWidth="168px"
            maxWidth="168px"
          ></Image>
        </Box>
        <Container size={"auto"} centerContent={false}>
          <Text fontSize={"16px"} color="rgba(0,0,0)">
            Udyog is your trusted business partner in India, with a proven track record of empowering businesses. We've helped over 8,000 clients achieve success, and currently maintain strong partnerships with more than 300 companies.
          </Text>
        </Container>
      </Flex>
      {/* A Line to divert the sections */}
      <Center height="64px">
        <Divider orientation="horizontal" borderColor="rgba(11,18,25,.5)" />
      </Center>
      <Flex justifyContent={'space-between'}>
        <FooterTagsCompiled></FooterTagsCompiled>
        <NewsLetterSection></NewsLetterSection>
      </Flex>
      {/* A Line to divert the sections */}
      <Center height="64px">
        <Divider orientation="horizontal" borderColor="rgba(11,18,25,.5)" />
      </Center>
      <Flex justifyContent={'space-between'} color='rgba(0,0,0)'>
        {/* <Text fontSize="14px" as={'button'}>Medicine</Text>
        <Text fontSize="14px" as={'button'}>Wellness</Text>
        <Text fontSize="14px" as={'button'}>Lab Tests</Text>
        <Text fontSize="14px" as={'button'}>Beauty</Text> */}
        <Text fontSize="14px" as={'button'}>Copyright &#169; All Rights Reserved.</Text>
        <Text fontSize="14px" as={'button'}>Udyog 2024</Text>
      </Flex>
    </Box>
  );
};

export default Footer;
